'use strict';

angular.module('webAgro1App').factory('SynchronizationService', function($http) {
  return {
    last_sync: function(model) {
      return $http.get(`${SERVER}v2/synchronization/last_sync?model=${model}`);
    }
  };
});
